<template>
  <div class="check-lists pad">

    <div class="flex">
      <b-input v-model="searchStr" placeholder="search" />
      <div class="flex-1 text-right">
        <button class="button is-success" @click="add">Add Check List</button>
      </div>
    </div>

    <table v-if="checkLists && checkLists.length" class="table is-hoverable is-striped is-bordered is-clickable">
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p of filteredCheckLists" :key="p._id">
          <td @click="view(p)">{{ p.name }}</td>
          <td>
            <div class="buttons">
              <button class="button is-small" @click.prevent="edit(p)">edit details</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="checkLists === null" class="pad text-center has-text-grey-light">
      <br /><br /><br /><br />
      <font-awesome-icon icon="spinner" size="3x" pulse />
    </div>
    <div v-else-if="!checkLists.length" class="pad text-center has-text-grey-light">
      <br /><br /><br /><br />
      There are no check lists
    </div>

  </div>
</template>

<script>
export default {
  name: 'ChecksLists',
  data () {
    return {
      searchStr: '',
      checkLists: null,
      filteredCheckLists: [],
      timer: null
    }
  },
  computed: {
    isAdmin () { return this.$store.getters.isAdmin }
  },
  watch: {
    searchStr () {
      if (!this.checkLists) {
        return
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(this.filter, 500)
    }
  },
  created () {
    this.subs.checkLists = this.$firestore.collection('checkLists')
      .onSnapshot(snapshot => {
        this.checkLists = this.$utils.snapshotToArr(snapshot)
        this.filter()
      })
  },
  methods: {
    filter () {
      let str = this.searchStr.trim().toLocaleLowerCase()
      if (str.length) {
        this.filteredCheckLists = this.checkLists.filter(p => p.name.toLocaleLowerCase().indexOf(str) >= 0)
      } else {
        this.filteredCheckLists = this.checkLists
      }
    },
    add () {
      this.$router.push(`/add-check-list`)
    },
    view (p) {
      this.$router.push(`/view-check-list/${p._id}`)
    },
    edit (p) {
      this.$router.push(`/edit-check-list/${p._id}`)
    }
  }
}
</script>

<style>

</style>
